import api from '../api';
import store from 'utils/store';
import track, {getSessionToken} from 'utils/track';
import {removeHeapTracking} from 'utils/heapTracking';
import {LOGOUT_EVENT} from './constants';

export default async function logout() {
	const req = api('post', '/auth/logout', {sessionToken: getSessionToken()});
	track('user', 'logged-out');
	store.clear();
	try {
		window.sessionStorage.clear();
		removeHeapTracking();
	} catch {
		// continue
	}
	await req;
	store.setItem(LOGOUT_EVENT, 'logout' + Math.random());
}
